import React from 'react';
import { Policy } from '../types/interface';
import { Heading, Badge, ToggleButton } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import OverRiddenPolicyTag from '@nile/banyan/src/Pebbles/OverRiddenPolicyTag';
import { SVGIcon } from '@superops/super-icons';

interface PolicyTitleProps {
  policyName: string;
  policy: Policy | null;
  showToggle: boolean;
  enabled?: boolean;
  disabled?: boolean;
  onEnabledChange?: (enabled: boolean) => void;
  isReadOnly?: boolean;
  isTitle?: boolean;
  showCrownIcon?: boolean;
}

function PolicyTitle(props: PolicyTitleProps) {
  const {
    policyName,
    policy,
    enabled,
    showToggle,
    disabled,
    onEnabledChange,
    isReadOnly,
    isTitle = false,
    showCrownIcon = false
  } = props;

  const handleToggleChange = (checked: boolean) => {
    if (onEnabledChange && !disabled) {
      onEnabledChange(checked);
    }
  };

  return (
    <div className="flex actr min-h-38">
      {showToggle && (
        <div className="tw-mr-2 flex actr">
          <ToggleButton
            value={enabled}
            onChange={handleToggleChange}
            size="small"
            locked={disabled}
          />
        </div>
      )}
      <Heading element="h1">
        <FormattedMessage id={policyName} />
      </Heading>

      {showCrownIcon && (
        <div className="ml-16 flex actr">
          <SVGIcon name="Crown" color="#F0A535" />
        </div>
      )}

      {policy?.inherited && (
        <div className="ml-16 flex actr">
          <Badge status="info" size="large">
            <FormattedMessage id="msp.app.common.inherited" />
          </Badge>
        </div>
      )}
      {policy?.overridden && (
        <OverRiddenPolicyTag
          policy={policy}
          isNewDelete={true}
          isReadOnly={isReadOnly}
        />
      )}
    </div>
  );
}

export default PolicyTitle;
